import { Action, Reducer } from 'redux';
import * as Actions from '../actions';
import { ProtocolPatientsState, ProtocolPatientsUnloadState } from '../states/ProtocolPatientsState';

type KnownAction =
    | Actions.ProtocolPatients.ProtocolPatientsExportDerivedExcelRequestAction
    | Actions.ProtocolPatients.ProtocolPatientsExportDerivedExcelSuccessAction
    | Actions.ProtocolPatients.ProtocolPatientsExportDerivedExcelFailureAction;

export const ProtocolPatientsReducer: Reducer<ProtocolPatientsState> = (
    state: ProtocolPatientsState | undefined,
    incomingAction: Action
): ProtocolPatientsState => {
    if (state === undefined) { return ProtocolPatientsUnloadState; }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'PROTOCOLPATIENTS_EXPORT_DERIVED_EXCEL_REQUEST':
            return { ...state, isLoading: true, isGeneratedSuccessfully: false, failOnGenerating: false, error: null, excelBlob: null };
        case 'PROTOCOLPATIENTS_EXPORT_DERIVED_EXCEL_SUCCESS':
            return { ...state, isLoading: false, isGeneratedSuccessfully: true, failOnGenerating: false, excelBlob: action.excelBlob, error: null };
        case 'PROTOCOLPATIENTS_EXPORT_DERIVED_EXCEL_FAILURE':
            return { ...state, isLoading: false, isGeneratedSuccessfully: false, failOnGenerating: true, error: action.error, excelBlob: null };
        default:
            return state;
    }
};
